import { AxiosResponse } from 'axios'
import { axios } from 'src/api'
import {
  ApiFetchIfEmailExistResponse,
  ApiFetchUserInfoResponse,
  ApiSaveUserDataPostData,
  ApiSaveUserDataResponse
} from './user.types'

export const apiFetchUserInfo = async (
  userToken: string,
  serverPath: string,
  userId: string
) => {
  const response: AxiosResponse<ApiFetchUserInfoResponse> = await axios.post(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/user/userinfo`,
    {
      userToken,
      id: userId
    }
  )
  return response
}

export const apiFetchIfEmailExist = async (
  userToken: string,
  serverPath: string,
  email: string
) => {
  const response: AxiosResponse<ApiFetchIfEmailExistResponse> =
    await axios.post(
      `https://${serverPath}/sialdPMS/web/resourcescrossorigin/user/uniquename`,
      {
        userToken,
        value: email
      }
    )
  return !(response.data.available === 'OK')
}

export const apiSaveUserData = async (
  data: Partial<ApiSaveUserDataPostData> & { userToken: string },
  serverPath: string
) => {
  const postData: Partial<ApiSaveUserDataPostData> = {
    ...data,
    userToken: data.userToken
  }
  const response: AxiosResponse<ApiSaveUserDataResponse> = await axios.post(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/user/savedata`,
    postData
  )
  return response
}
